import Axios, { AxiosRequestConfig, AxiosError, isAxiosError } from 'axios';
import { logoutEvents } from '@/shared/emmiters';
import consola from 'consola';
export const AXIOS_INSTANCE = Axios.create({
    // baseURL: process.env.API_URL,
});
// Request interceptor for auth
AXIOS_INSTANCE.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('session');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

// Response interceptor for error handling
AXIOS_INSTANCE.interceptors.response.use(
    (config) => config,
    (error) => {
        if (isAxiosError(error) && error.response && [401, 403].includes(error.response.status)) {
            try {
                logoutEvents.emit(error.response)
            } catch (error) {
                consola.log('error', error)
            }
        }
        return Promise.reject(error);
    });

export const customInstance = <T>(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
): Promise<T> => {
    return AXIOS_INSTANCE({
        ...config,
        ...options,
    })
        .then(({ data }) => data);
};
export type ErrorType<Error> = AxiosError<Error>;
export type BodyType<BodyData> = BodyData;